export default __webpack_public_path__ + "static/media/Our-Vision.521cf575.png";